import { Component, ChangeDetectionStrategy, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges, SimpleChange } from '@angular/core';
import { XmlReportDataService } from '../../services/xml-report-data.service';
import { HighChartDataBase } from '../../models/high-chart-data-base';
import { ChartConfigBase } from '../../models/chart-config-base';

import * as Highcharts from 'highcharts';


@Component({
    selector: 'xml-report-print',
    template: '<div #chart></div>',
    host: { 'cid': 'XmlReportPrint' },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class XmlReportPrintComponent implements OnChanges {
    @Input() config: ChartConfigBase;
    @Output() passChartData = new EventEmitter();
    @ViewChild('chart', {static: false}) public chartEl: ElementRef;

    chartData: HighChartDataBase;

    constructor( 
        private xmlService: XmlReportDataService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        let config: SimpleChange = changes['config'];
        if (config) this.getChart();
    }

    getChart() {
        if (!this.config || !this.config.reportName) return; 

        this.xmlService.getHighChartData(this.config, null).subscribe((data: HighChartDataBase) => {
                this.passChartData.emit(data);
                this.chartData = data;
                let options: any = data.getHighChartOptions();
                options = this.formatOptions(options);
                Highcharts.chart(options);
            }, 
            (error) => {
                console.log(error);
            }
        );
    }

    formatOptions(options) {
        options.chart.height = 400; //Alltid 400px i höjd på diagram i utskrift  (Koll på nuläget)
        options.chart.renderTo = this.chartEl.nativeElement;
        options.credits.enabled = false;
        options.exporting.enabled = false;

        if (options.yAxis.tickInterval == null && options.yAxis.tickAmount == null)
            options.yAxis.tickAmount = 6;
        
        if (options.title.style == null) 
            options.title.style = {color: '#333', fontSize: '14px'};
        else {
            options.title.style.color = '#333';
            options.title.style.fontSize = '14px';
        } 
        options.title.align = 'left';
        options.title.x = 20;
        options.title.y = 18;

        if (options.subtitle.style == null) 
            options.subtitle.style = {color: '#666', fontSize: '14px'};        
        else {
            options.subtitle.style.color = '#666';
            options.subtitle.style.fontSize = '14px';
        }
        options.subtitle.align = 'left';
        options.subtitle.x = 20;

        if (this.chartData.customDataLabels != null) {
            options.title.y = 7;
            options.subtitle.y = 27;
        }

        if (options.xAxis.labels != null) {
            if (options.xAxis.labels.style != null)
                options.xAxis.labels.style.fontSize = '8pt';
            else
                options.xAxis.labels.style = {fontSize: '8pt'};
        }
        if (options.yAxis.labels != null) {
            if (options.yAxis.labels.style != null)
                options.yAxis.labels.style.fontSize = '8pt';
            else
                options.yAxis.labels.style = {fontSize: '8pt'};
        }
        if (options.xAxis.title != null) {
            if (options.xAxis.title.style != null)
                options.xAxis.title.style.fontSize = '10pt';
            else
                options.xAxis.title.style = {fontSize: '10pt'};
        }
        if (options.yAxis.title != null) {
            if (options.yAxis.title.style != null)
                options.yAxis.title.style.fontSize = '10pt';
            else
                options.yAxis.title.style = {fontSize: '10pt'};
        }

        if (options.legend.itemStyle == null)
            options.legend.itemStyle = {fontSize: '10pt'};
        else 
            options.legend.itemStyle.fontSize = '10pt';

        options.legend.align = 'left';
        options.legend.margin = 0;
        options.legend.x = 20;
        return options;
    }

}
